/**
 * Pam Ajans Multicolumn – Basit ve sağlam slider.
 * Owl tarzı: autoplay slide-by-slide ilerler, drag/touch her zaman aktif.
 * Hover/touch'ta autoplay durur, ayrılınca devam eder.
 */
(function () {
	function toBoolean(string) {
		return string === "true";
	}

	function initPamAjansMulticolumn() {
		var sliders = document.querySelectorAll(".pam-ajans-multicolumn-slider");
		if (!sliders.length) return;

		sliders.forEach(function (slider) {
			var sectionId = slider.dataset.id;
			var perRow = slider.dataset.perRow;
			var mobileR = slider.dataset.mobile;
			var autoplay = toBoolean(slider.dataset.autoplay);
			var rawSpeed = parseFloat(slider.dataset.speed);
			// Slide'lar arası bekleme süresi (saniye → ms)
			var autoplayDelay = Math.min(Math.max(rawSpeed * 1000, 1000), 30000);

			var swiperEl = document.querySelector("#" + sectionId + " .swiper");
			if (!swiperEl) return;

			var prevBtn = swiperEl.querySelector(".pam-mc-nav--prev");
			var nextBtn = swiperEl.querySelector(".pam-mc-nav--next");

			if (swiperEl.swiper) {
				swiperEl.swiper.destroy(true, true);
			}

			var swiperConfig = {
				loop: true,
				speed: 600,
				slidesPerView: mobileR,
				spaceBetween: 0,
				allowTouchMove: true,
				simulateTouch: true,
				grabCursor: true,
				touchEventsTarget: "container",
				longSwipesRatio: 0.3,
				threshold: 5,
				resistance: true,
				resistanceRatio: 0.85,
				breakpoints: {
					750: {
						slidesPerView: Math.min(2, +perRow),
						navigation: { enabled: false },
					},
					990: {
						slidesPerView: +perRow + 0.4,
						navigation: { enabled: false },
					},
				},
				mousewheel: {
					enabled: true,
					forceToAxis: true,
					sensitivity: 1,
					thresholdDelta: 15,
					thresholdTime: 200,
					releaseOnEdges: true,
				},
				navigation: prevBtn && nextBtn ? {
					prevEl: prevBtn,
					nextEl: nextBtn,
					enabled: true,
				} : false,
			};

			if (autoplay) {
				swiperConfig.autoplay = {
					delay: autoplayDelay,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				};
			}

			var swiper = new Swiper(swiperEl, swiperConfig);

			// Mobil: dokunma sırasında autoplay durdur, bırakınca devam et
			if (autoplay) {
				var touchTimer = null;

				slider.addEventListener("touchstart", function () {
					swiper.autoplay.stop();
				}, { passive: true });

				slider.addEventListener("touchend", function () {
					if (touchTimer) clearTimeout(touchTimer);
					touchTimer = setTimeout(function () {
						swiper.autoplay.start();
					}, 1000);
				}, { passive: true });
			}

			// Overlay pointer-events: none olduğu için tıklamada linke git (drag değilse)
			var CLICK_THRESHOLD = 8;
			var pointerStart = { x: 0, y: 0 };

			slider.addEventListener("pointerdown", function (e) {
				pointerStart.x = e.clientX;
				pointerStart.y = e.clientY;
			});

			slider.addEventListener("click", function (e) {
				var slide = e.target.closest(".swiper-slide");
				if (!slide) return;
				var dx = e.clientX - pointerStart.x;
				var dy = e.clientY - pointerStart.y;
				if (Math.abs(dx) > CLICK_THRESHOLD || Math.abs(dy) > CLICK_THRESHOLD) return;
				var link = slide.querySelector(".multicolumn__link-overlay[href]");
				if (link && link.href) {
					e.preventDefault();
					window.location.href = link.href;
				}
			});
		});
	}

	document.addEventListener("DOMContentLoaded", function () {
		initPamAjansMulticolumn();
	});

	document.addEventListener("shopify:section:load", function () {
		initPamAjansMulticolumn();
	});
})();
